import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DirectRfqService } from '../../services/direct.rfq.service';
import { FormsModule } from '@angular/forms';
import { TooltipOnEllipsisDirective } from '../directives/tooltip-on-ellipsis.directive';
import { ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { QuoteAssistV2Service } from '../../services/quote-assist-v2.service';
import { QuoteAssistv2BaseComponent } from '../quoteAssist-V2/main/quote-assist-v2-base.component';
import { MixPanelEvents } from '../shared/enums';
@Component({
  selector: 'app-direct-rfq-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    FormsModule,
    TooltipOnEllipsisDirective,
  ],
  templateUrl: './direct-rfq-list.component.html',
  styleUrls: ['./direct-rfq-list.component.scss'],
})
export class DirectRfqListComponent extends QuoteAssistv2BaseComponent implements OnInit {
  rfqList: any[] = [];
  currentPage: number = 1; // Track current page
  itemsPerPage: number = 3; // Number of items per page
  isData: boolean = false;
  showLoader: boolean = true;
  copiedRfqId: string | null = null;
  queryParams = {
    companyId: 0,
    rfqPartId: 0,
    contactId: 0,
    isTrackingEnabled: 'false',
    integration: '',
    emailId: '',
  };
  showLoaderwhilesendemailOrDownload: boolean = false;
  isOpenFilterDropdown = false;
  toggleFilterDropdown() {
    this.isOpenFilterDropdown = !this.isOpenFilterDropdown;
  }

  isOpenShortDropdown = false;
  toggleShortDropdown() {
    this.isOpenShortDropdown = !this.isOpenShortDropdown;
  }

  hideFilterByDropdown() {
    this.isOpenFilterDropdown = false;
    this.isOpenShortDropdown = false;
  }

  sortOption: string = 'Newest RFQ';
  sortOptions = [
    { value: 'Newest RFQ', label: 'Newest RFQ' },
    { value: 'Oldest RFQ', label: 'Oldest RFQ' },
    { value: 'Earliest Quote Date', label: 'Earliest Quote Date' },
    { value: 'Latest Quote Date', label: 'Latest Quote Date' },
    { value: 'Earliest Delivery Date', label: 'Earliest Delivery Date' },
    { value: 'Latest Delivery Date', label: 'Latest Delivery Date' },
  ];
  filteredSortOptions = [...this.sortOptions];
  searchQuery: string = '';
  originalRfqList: any[] = [];
  rfqTypes = [
    { value: '', label: 'Select RFQ Type' },
    { value: 'Private RFQ', label: 'Private RFQ' },
    { value: 'Self-Created RFQ', label: 'Self-Created RFQ' },
  ];
  selectedRfqType: string = '';

  constructor(
    private directRfqService: DirectRfqService,
    private activatedRoute: ActivatedRoute,
    private quoteAssistV2Service: QuoteAssistV2Service,
    private toastrService: ToastrService
  ) {
    super();
  }

  ngOnInit(): void {
    // TODO: Replace with actual API call
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['companyId']) {
        this.queryParams.companyId = Number(params['companyId']);
        this.queryParams.rfqPartId = Number(params['rfqPartId']);
        this.queryParams.contactId = Number(params['contactId']);
        this.queryParams.isTrackingEnabled = params['isTrackingEnabled'];
        this.queryParams.integration = params['integration'];
        this.queryParams.emailId = params['emailId'] || '';
        // Map emailId to email for Mixpanel tracking
        if (this.queryParams.emailId) {
          (this.queryParams as any).email = this.queryParams.emailId;
        }
        // this.isTrackingEnabled = this.queryParams.isTrackingEnabled ;
      }
    });
    if (this.queryParams.companyId) {
      this.getDirectRFQs(this.queryParams.companyId);
    } else {
      // For testing UI without data, hide the loader after a short delay
      setTimeout(() => {
        this.showLoader = false;
        this.isData = false; // Show "No Direct RFQ Found" message
      }, 500);
    }
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  // Function to get the appropriate CSS class for status
  getStatusClass(quoteStatus: string): string {
    switch (quoteStatus) {
      case 'Draft':
        return 'status-draft';
      case 'ReadyToSend':
        return 'status-ready';
      case 'Submit':
        return 'status-sent';
      default:
        return '';
    }
  }
  // Function to get the display label for status
  getStatusLabel(quoteStatus: string): string {
    switch (quoteStatus) {
      case 'Draft':
        return 'Draft';
      case 'ReadyToSend':
        return 'Ready to Send';
      case 'Submit':
        return 'Ready to Send';
      case 'Open':
        return 'Open';
      default:
        return quoteStatus;
    }
  }
  redirectToAssistPage() {
    // this.openPopup('direct-assist', { source: 'MFGDirect' });
     this.openPopup('quote-assist-version', { source: 'MFGDirect' });
  }

  openPopup(url: string, otherData: any = null): void {
    let navQueryParams: any = {
      companyId: this.queryParams.companyId,
      contactId: this.queryParams.contactId,
      isTrackingEnabled: this.queryParams.isTrackingEnabled,
      integration: otherData.source,
      emailId: this.queryParams.emailId,
    };

    if (otherData) {
      navQueryParams = Object.assign(navQueryParams, otherData);
    }
    if (window.parent) {
      window.parent.postMessage(
        {
          openAssistOrSummaryInPopup: true,
          assistOrSummaryUri: url,
          assistOrSummaryQueryParams: navQueryParams,
        },
        '*'
      );
    }
  }
  getDirectRFQs(companyId: number): void {
    this.showLoader = true;
    this.directRfqService.getAllDirectRFQsByCompanyId(companyId).subscribe({
      next: (response) => {
        this.originalRfqList = response.data || [];
        this.applyFiltersAndSort();
        this.showLoader = false;
      },
      error: (error) => {
        this.isData = false;
        this.showLoader = false;
      },
    });
  }

  applyFiltersAndSort(): void {
    let filteredData = [...this.originalRfqList];

    // Apply search filter
    if (this.searchQuery?.trim()) {
      const searchLower = this.searchQuery.toLowerCase().trim();
      filteredData = filteredData.filter(
        (rfq) =>
          rfq.rfqName?.toLowerCase().includes(searchLower) ||
          rfq.rfqSequenceId?.toString().toLowerCase().includes(searchLower) ||
          rfq.buyerCompanyName?.toLowerCase().includes(searchLower) ||
          rfq.buyerEmailAddress?.toLowerCase().includes(searchLower)
      );
    }

    // Apply RFQ Type filter
    if (this.selectedRfqType && this.selectedRfqType !== '') {
      filteredData = filteredData.filter((rfq) => {
        if (this.selectedRfqType === 'Private RFQ') {
          return rfq.source === 'SUW';
        } else if (this.selectedRfqType === 'Self-Created RFQ') {
          return rfq.source === 'MFGDirect';
        }
        return true;
      });
    }

    // Apply sorting
    filteredData.sort((a, b) => {
      // Helper function to handle null dates
      const handleNullDates = (
        dateA: any,
        dateB: any,
        isAscending: boolean
      ) => {
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1; // Push null dates to the end
        if (!dateB) return -1; // Push null dates to the end
        return isAscending
          ? new Date(dateA).getTime() - new Date(dateB).getTime()
          : new Date(dateB).getTime() - new Date(dateA).getTime();
      };

      // First check if either record has null dates for the current sort option
      let aHasNullDate = false;
      let bHasNullDate = false;

      switch (this.sortOption) {
        case 'Earliest Quote Date':
        case 'Latest Quote Date':
          aHasNullDate = !a.quoteBy;
          bHasNullDate = !b.quoteBy;
          break;
        case 'Earliest Delivery Date':
        case 'Latest Delivery Date':
          aHasNullDate = !a.deliverBy;
          bHasNullDate = !b.deliverBy;
          break;
        default:
          aHasNullDate = false;
          bHasNullDate = false;
      }

      // If one has null date and the other doesn't, push the one with null date to the end
      if (aHasNullDate !== bHasNullDate) {
        return aHasNullDate ? 1 : -1;
      }

      // If both have null dates, sort them by createdOn (newest first)
      if (aHasNullDate && bHasNullDate) {
        return (
          new Date(b.createdOn || 0).getTime() -
          new Date(a.createdOn || 0).getTime()
        );
      }

      // For records without null dates, apply the selected sort
      switch (this.sortOption) {
        case 'Newest RFQ':
          return (
            new Date(b.createdOn || 0).getTime() -
            new Date(a.createdOn || 0).getTime()
          );
        case 'Oldest RFQ':
          return (
            new Date(a.createdOn || 0).getTime() -
            new Date(b.createdOn || 0).getTime()
          );
        case 'Earliest Quote Date':
          return new Date(a.quoteBy).getTime() - new Date(b.quoteBy).getTime();
        case 'Latest Quote Date':
          return new Date(b.quoteBy).getTime() - new Date(a.quoteBy).getTime();
        case 'Earliest Delivery Date':
          return (
            new Date(a.deliverBy).getTime() - new Date(b.deliverBy).getTime()
          );
        case 'Latest Delivery Date':
          return (
            new Date(b.deliverBy).getTime() - new Date(a.deliverBy).getTime()
          );
        default:
          return 0;
      }
    });

    this.rfqList = filteredData;
    this.isData = this.rfqList.length > 0;

    // Ensure pagination is applied after sorting
    const maxPage = Math.ceil(this.rfqList.length / this.itemsPerPage);
    if (this.currentPage > maxPage) {
      this.currentPage = Math.max(1, maxPage);
    }
  }

  onSortChange(): void {
    this.applyFiltersAndSort();
  }

  onSearchChange(): void {
    this.applyFiltersAndSort();
  }

  onSendQuoteClick(rfqData: any): void {
    if (rfqData.source === 'SUW') {
      this.updateSeenTime(
        rfqData.rfqId,
        this.queryParams.contactId,
        this.queryParams.companyId
      );
    }
    // Navigate to quote-assist-version component with query parameters
    // this.openPopup('direct-quote-summary',{
     this.openPopup('quote-assist-version', {
      rfqId: rfqData.rfqId,
      rfqPartId: rfqData.rfqPartId,
      source: rfqData.source,
    });
  }
  onContinueQuoteClick(rfqData: any): void {
    this.openPopup('direct-quote-summary', {
      rfqId: rfqData.rfqId,
      rfqPartId: rfqData.rfqPartId,
      source: rfqData.source,
    });
  }

  copyToClipboard(text: string, rfqId: string) {
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copiedRfqId = rfqId; // Set the copied ID
          setTimeout(() => (this.copiedRfqId = null), 2000); // Reset after 2 sec
        })
        .catch((err) => {
          // Handle clipboard copy error silently
        });
    } else {
      // Fallback for restricted browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.copiedRfqId = rfqId;
        setTimeout(() => (this.copiedRfqId = null), 2000);
      } catch (err) {
        // Handle fallback copy error silently
      }
      document.body.removeChild(textArea);
    }
  }

  getShortenedId(id: string): string {
    return id ? id.split('-')[0] : '--';
  }

  getFilteredSortOptions(): any[] {
    if (this.selectedRfqType === 'Self-Created RFQ') {
      return this.sortOptions.filter(
        (option) =>
          option.value === 'Newest RFQ' || option.value === 'Oldest RFQ'
      );
    }
    return this.sortOptions;
  }

  onRfqTypeChange(): void {
    // Reset sort option if it's no longer valid for the selected RFQ type
    const validOptions = this.getFilteredSortOptions();
    if (!validOptions.some((option) => option.value === this.sortOption)) {
      this.sortOption = 'Newest RFQ';
    }
    this.applyFiltersAndSort();
  }

  clearFilters(): void {
    this.sortOption = 'Newest RFQ';
    // this.selectedRfqType = 'Private RFQ';
    this.searchQuery = '';
    this.applyFiltersAndSort();
  }
  updateSeenTime(rfqId: string, contactId: number, companyId: number): void {
    this.directRfqService
      .updateSeenTime(rfqId, contactId, companyId)
      .subscribe({
        next: (response) => {},
      });
  }

  // Drawer methods
  openRfqDetailsDrawer(rfqData: any): void {
    if (window.parent) {
      window.parent.postMessage(
        {
          privateRfqSideDrawer: true,
          data: rfqData,
        },
        '*'
      );
    }
  }

  formatCertificateList(rfq: any): string {
    if (
      !rfq?.certificateAndQualification ||
      rfq.certificateAndQualification.length === 0
    ) {
      return '-';
    }
    return rfq.certificateAndQualification.join(', ');
  }

  downloadPdfFile(rfqData:any) {
   const  rfqId=rfqData.rfqId;
   const version=rfqData.version?rfqData.version:1;
   console.log('version',version);
    this.showLoaderwhilesendemailOrDownload = true;
    const pdfParams: any = {
      version: version,
      companyId: this.queryParams.companyId,
      rfqId: rfqId,
      contactId: this.queryParams.contactId
    };
    
    this.quoteAssistV2Service.getWebsiteAndPrivateRfqQuotePDF(pdfParams).subscribe({
      next: (response) => {
        this.downloadPdfFileFromResponse(response,pdfParams);        
        this.toastrService.success('PDF downloaded successfully', 'Success');
        this.showLoaderwhilesendemailOrDownload = false;
        if( this.queryParams.integration === 'MFGDirect'){
          this.addTracking(MixPanelEvents.DownloadPDfSelfCreated, this.queryParams);
        }else{
          this.addTracking(MixPanelEvents.DownloadPDfWebsiteSubmitted, this.queryParams);
        }
      },
      error: (error) => {
        this.showLoaderwhilesendemailOrDownload = false;
        console.error('PDF download error:', error);
        this.toastrService.error('Failed to download PDF', 'Error');
      }
    });
  }
  sendViaEmail(rfq:any){
    // Prepare the request payload for sending quote email to buyer
    const emailRequest = {
      companyId: this.queryParams.companyId,
      buyerCompanyEmail: rfq.buyerEmailAddress || '',
      supplierId: this.queryParams.contactId,
      rfqId: rfq.rfqId || '',
      quoteStatus: rfq.quoteStatus
    };

    // Call the API to send quote email to buyer
    this.showLoaderwhilesendemailOrDownload = true;
    this.quoteAssistV2Service.sendQuoteEmailToBuyer(emailRequest).subscribe({
      next: (response) => {
        this.showLoaderwhilesendemailOrDownload = false;
        if (response.success) {
          console.log('Quote email sent successfully:', response.message);
          // You can add a success notification here
          if(this.queryParams.integration === 'MFGDirect'){
            this.addTracking(MixPanelEvents.SendViaEmail, this.queryParams);
          }else{
            this.addTracking(MixPanelEvents.SendViaEmailWebsiteSubmitted, this.queryParams);
          }
          this.toastrService.success('Quote email sent successfully');
          
        } else {
          console.error('Failed to send quote email:', response.error);
          // You can add an error notification here
          // this.showErrorMessage('Failed to send quote email');
        }
      },
      error: (error) => {
        this.showLoaderwhilesendemailOrDownload = false;
        console.error('Error sending quote email:', error);
        // You can add an error notification here
        // this.showErrorMessage('Error sending quote email');
      }
    });
  }
}
